import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import GenericWizardBlockData from '../../../Models/Content/GenericWizardBlockData';
import GenericWizard from './GenericWizardBlock';

export default class GenericWizardBlock extends EpiComponent<GenericWizardBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <GenericWizard context={this.getContext()} iContent={this.props.data}/>;
  }
}
